module.exports = __webpack_public_path__ + "img/retail-yellow.d880d58e.png";